<template>
  <div style="text-align: center;">
    <b-form-group class="mt-2">
      <b-row v-if="enableASAP">
        <b-col>
          <b-form-radio button button-variant="light" v-model="asap" :value=true class="py-2 mx-1 pnd-buttons" @input="emitPickupTime">&#128168; ASAP</b-form-radio>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>{{ noASAPMessage }}</b-col>
      </b-row>
      <b-row v-if="selectedLocation.allow_appointments">
        <b-col>
          <b-form-radio button button-variant="light" v-model="asap" v-b-modal.appointment-set :value=false class="py-2 mx-1 pnd-buttons">&#128197; LATER</b-form-radio>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>{{ noLaterMessage }}</b-col>
      </b-row>
    </b-form-group>

    <div v-if="asap==false && appointDate">
      <b-row><b-col><b>Pickup Time:</b></b-col></b-row>
      <b-row><b-col>{{ appointDate | toTextDate }} {{ pickupTime.slice(0,5) }}</b-col></b-row>
    </div>

    <b-modal id="appointment-set" :ok-disabled="!pickupState" @ok="emitPickupTime" @show="retrievePickupTimes">
      <b-row>
        <b-col style="text-align:center;">
          <b-calendar
            v-model="appointDate"
            :date-disabled-fn="dateDisabled"
            locale="en-US"
            @input="retrievePickupTimes()"
          >
          </b-calendar>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-timepicker
            class="mt-2"
            locale="en"
            placeholder="Choose Time"
            :value="selectedLocation.next_time_slot"
            v-model="pickupTime"
            :state="pickupState"
            :minutes-step="selectedLocation.timeslot_increment"
            @shown="setDefaultTime"
            @hidden="emitPickupTime"
            style="width:270px; margin: auto;"
          ></b-form-timepicker>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ChooseWhen',
  props: ['selectedLocation', 'selectedMenuDate', 'todaysHours'],
  data () {
    return {
      asap: true,
      invaliddays: [],
      validdates: [],
      pickupTime: '',
      timeslots: [],
      appointDate: '',
      nextTimeSlot: '',
      todaysNextTimeSlot: '',
      todaysDate: moment().format('YYYY-MM-DD'),
    }
  },

  watch: {
    enableASAP: function() {
      this.$emit('switch-asap', this.actualASAP)
    }
  },

  computed: {
    pickupState: function() {
      // Check to see if the current pickupTime is in the list of available timeslots
      if (this.timeslots.indexOf(moment(this.appointDate + 'T'+this.pickupTime).format('YYYY-MM-DD HH:mm:ss')) == -1) {
        return false;
      } else {
        return true;
      }
    },

    noASAPMessage: function() {
      if (this.hourWait) {
        return 'There is over an hour wait for the next order, please choose a time if available.'
      } else if (!this.todaysHours) {
        return 'We are closed today. Please order ahead, or visit us tomorrow.'
      } else if (this.todaysNextTimeSlot=='') {
        return 'We are no longer serving today. Please order ahead if available, or visit us tomorrow.'
      } else {
        return ''
      }
    },

    noLaterMessage: function() {
      return ''
      //return 'This location is unable to accept orders by date/time currently. Please visit us again at a later time.'
    },

    hourWait: function() {
      if (moment().add(1, 'hour').isBefore(moment(this.todaysDate+'T'+this.todaysNextTimeSlot))) {
        return true;
      } else {
        return false;
      }
    },

    enableASAP: function() {
      if (this.hourWait  || this.todaysNextTimeSlot == '' || !this.todaysHours) {
        return false;
      } else {
        return true;
      }
    },

    actualASAP: function() {
      if (this.enableASAP) {
        return this.asap;
      } else {
        return false;
      }
    }
  },

  methods: {
    emitPickupTime() {
      var appointDate = this.appointDate ? this.appointDate : this.selectedMenuDate;
      if (this.actualASAP) {
        this.pickupTime = this.todaysNextTimeSlot
        appointDate = this.todaysDate
      }
      // const asap = this.enableASAP ? this.asap : false
      this.$emit('emit-selected-datetime', appointDate, this.pickupTime, this.actualASAP, this.pickupState);
    },

    emitError(error, severity, stage) {
      this.$emit('emit-error', error, severity, stage, '');
    },

    setDefaultTime() {
      if (this.pickupTime == '') {
        this.pickupTime = this.nextTimeSlot
      }
    },

    retrieveCalendar() {
      // default is active only
      this.$api.get('locations/'+this.selectedLocation.id+'/calendar')
        .then(response => {
         // JSON responses are automatically parsed.
         this.invaliddays = response.data.invaliddays;
         // move the days around so they are compatible with JS (Start of week is Sunday in JS)
         this.invaliddays = this.invaliddays.map(function(d) {
           return (d==6) ? 0 : d+1
         })
         this.validdates = response.data.validdates;
         // Convert all dates to YYYY-MM-DD
         this.validdates = this.validdates.map(date=>moment.parseZone(date).format('YYYY-MM-DD'))
        })
        .catch(e => {
          this.emitError(e.stack, 3, 'retrieveCalendar');
        })
    },

    async retrievePickupTimes() {
      const appointDate = this.appointDate ? this.appointDate : this.selectedMenuDate;
      const res = await this.$api.get('locations/'+this.selectedLocation.id+'/pickuptimes?date='+appointDate)
      try {
        if (res.data.success==true) {
          this.timeslots = await res.data.time_slots
          this.nextTimeSlot = await res.data.next_time_slot
          // For setting ASAP as default or not
          if (appointDate == this.todaysDate) {
            this.todaysNextTimeSlot = res.data.next_time_slot
          }
        }
      }
      catch (error) {
       this.emitError(error.stack, 3, 'retrievePickupTimes');
      }
    },

    dateDisabled(ymd, date) {
      const weekday = date.getDay()
      return this.invaliddays.includes(weekday) && !this.validdates.includes(ymd);
    },

    async loadComponentData() {
      this.retrieveCalendar();
      await this.retrievePickupTimes();
      await this.setDefaultTime()
      this.emitPickupTime();
    }

  },

  mounted() {
    this.loadComponentData();
  }

}
</script>
<style>


</style>
